import { GlobalSettingsService } from './../../core/gobal-settings.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { SessionService } from './session.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class AuthGuard implements CanActivate {
    environment: boolean = environment.BP_ACTIF;
    constructor(
        private router: Router,
        private sessionService: SessionService,
        private globalSettingsService: GlobalSettingsService,
    ) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        this.sessionService.setStateUrl(decodeURI(state.url));
        if (!this.sessionService.isLoggedIn()) {
            // not logged in
            this.router.navigate(['/login']);
            return false;
        }
        if (!this.globalSettingsService.bpDisplayState  || !this.environment) {
            // tslint:disable-next-line
            if (state.url.includes('facturation-bp') || state.url.includes('validate-bp') || state.url.includes('select-bc-for-create-bp')  || state.url.includes('create-bp')) {
                this.router.navigate(['/']);
                return false;
            }
        }
        return true;
      }
}

@Injectable()
export class DroitInterfaceGuard implements CanActivate {
    environment: boolean = environment.BP_ACTIF;
    canImport = false ;
    canGenerate = false;
    constructor(
        private router: Router
    ) {}
    canActivate(): boolean {
        const user = JSON.parse(localStorage.getItem('CURRENT_USER'));
        const droitsGenerate = user.droits.filter(droit =>
            (droit.niveau === 5 || droit.niveau === 10) &&
            (droit.type.toUpperCase() === 'INTERFACE')
        );
        const droitsImport = user.droits.filter(droit =>
            (droit.niveau === 2 || droit.niveau === 3 || droit.niveau === 4 || droit.niveau === 10) &&
            (droit.type.toUpperCase() === 'INTERFACE')
        );
        if (droitsGenerate && droitsGenerate.length > 0){
          this.canGenerate = true;
        }
        if (droitsImport && droitsImport.length > 0){
          this.canImport = true;
        }
        if (!this.canGenerate && !this.canImport) {
            this.router.navigate(['**']);
        }
        return true;
    }
}

@Injectable()
export class DroitAdminGuard implements CanActivate {
    createUser = false;
    referentiel = false;
    droitInterface = false;
    droitInterfaceGlobal = false;
    droitAdmin2 = false;
    referentielGroupe = false;
    constructor( private router: Router,
                 private route: ActivatedRoute) {
    }
    canActivate(
        route: ActivatedRouteSnapshot,
        router: RouterStateSnapshot
    ): boolean {
    
        const user = JSON.parse(localStorage.getItem('CURRENT_USER'));
        const droitAdmin = user.droits.filter(droit =>
            (droit.niveau === 1) &&
            (droit.type.toUpperCase() === 'ADMIN')
        );
        if (droitAdmin && droitAdmin.length > 0){
          this.createUser = true;
        }
        const droitAdmin2 = user.droits.find(droit =>
            (droit.niveau === 2) &&
            (droit.type.toUpperCase() === 'ADMIN')
        );
        if (droitAdmin2){
            this.droitAdmin2 = true;
        }

        const droitAdminReferentielGroupe = user.droits.find(droit =>
            (droit.niveau === 2) && (droit.idSociete === 1) &&
            (droit.type.toUpperCase() === 'ADMIN')
        );
        if (droitAdminReferentielGroupe){
            this.referentielGroupe = true;
        }

        const droitInterfaceGlobal = user.droits.find(droit =>
            (droit.type.toUpperCase() === 'INTERFACE')
        );
        if (droitInterfaceGlobal){
            this.droitInterfaceGlobal = true;
        }

        const id = route.paramMap.get('id');
        if (id){
            const droitAdminReferentiel = user.droits.find(droit =>
                (droit.niveau === 2) && (droit.idSociete === Number(id)) &&
                (droit.type.toUpperCase() === 'ADMIN')
            );
            if (droitAdminReferentiel){
                this.referentiel = true;
            }
            const droitInterface = user.droits.find(droit =>
                (droit.idSociete === Number(id)) &&
                (droit.type.toUpperCase() === 'INTERFACE')
            );
            if (droitInterface){
                this.droitInterface = true;
            }
        }
        switch (route.url[0].path) {
            case 'list-user':
                if (!this.createUser && !this.droitAdmin2) {
                    this.router.navigate(['**']);
                }
                break;
            case 'user-record':
                if (!this.createUser && !this.droitAdmin2) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-referentiel':
                if (!this.droitAdmin2 && !this.droitInterfaceGlobal) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-na':
                if (!this.referentielGroupe) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-societe':
                if (!this.referentielGroupe) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-cgCharge':
                if (!this.referentielGroupe) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-tva':
                if (!this.referentielGroupe) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-modeRegl':
                if (!this.referentielGroupe) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-condRegl':
                if (!this.referentielGroupe) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-site':
                if (!this.referentiel) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-activite':
                if (!this.referentielGroupe) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-destination':
                if (!this.referentielGroupe) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-article/:id':
                if (!this.referentiel) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-ca1':
                if (!this.referentiel) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-ca2':
                if (!this.referentiel) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-typComp':
                if (!this.referentiel) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-comp':
                if (!this.referentiel) {
                    this.router.navigate(['**']);
                }
                break;
            case 'gestion-pediode-sage':
                if (!this.droitInterface) {
                    this.router.navigate(['**']);
                }
                break;
        }
        return true;
    }
}

